// extracted by mini-css-extract-plugin
export default {"root":"Pagination_root__xRM82","button":"Pagination_button__yqPye","ellipsis":"Pagination_ellipsis__KOzDx","active":"Pagination_active__DFsb2"};